import { useQuery } from '@tanstack/react-query'
import { getWorkerJob } from '../services/api.js'

const FINISHED = new Set(['completed', 'failed'])

/**
 * Suit une tâche de fond exécutée par le worker (GET /api/worker-jobs/:id).
 * Interroge l'API toutes les 3 s tant que la tâche n'est pas terminée, puis s'arrête.
 */
export function useWorkerJob(jobId) {
  const query = useQuery({
    queryKey: ['workerJob', jobId],
    queryFn: () => getWorkerJob(jobId),
    enabled: Boolean(jobId),
    refetchInterval: (q) => (FINISHED.has(q.state.data?.status) ? false : 3000),
    refetchIntervalInBackground: true,
  })

  const job = query.data ?? null
  return {
    ...query,
    job,
    isFinished: FINISHED.has(job?.status),
  }
}
